var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0px 3%"
    }
  }, [_c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#006E4B"
    }
  }, [_vm._v("身份证")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "border": "1px solid #e9e9e9",
      "border-radius": "5px",
      "padding": "0 10px",
      "height": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "13px 0px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "top-start",
      "trigger": "click"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.from.card_photo,
      "target": "_blank",
      "title": "查看最大化图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "800px",
      "height": "500px"
    },
    attrs: {
      "src": _vm.from.card_photo
    }
  })]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "65px",
      "height": "73px",
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference",
      "src": _vm.from.card_photo
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.from.staff_name) + "-身份证附件.jpg")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "36px 0px"
    },
    attrs: {
      "span": 6
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#006E4B"
    }
  }, [_vm._v("银行卡")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "border": "1px solid #e9e9e9",
      "border-radius": "5px",
      "padding": "0 10px",
      "height": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "13px 0px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "top-start",
      "trigger": "click"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.from.bank_photo,
      "target": "_blank",
      "title": "查看最大化图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "800px",
      "height": "500px"
    },
    attrs: {
      "src": _vm.from.bank_photo
    }
  })]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "65px",
      "height": "73px",
      "cursor": "pointer"
    },
    attrs: {
      "slot": "reference",
      "src": _vm.from.bank_photo
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.from.staff_name) + "-银行卡附件.jpg")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "36px 0px"
    },
    attrs: {
      "span": 6
    }
  })], 1)], 1)])], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86af632e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabs/accessory.vue
// module id = null
// module chunks = 